export { default } from '../badge-new';
export type { BadgeNewProps } from '../types';
